var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "choice-type-import" }, [
    _c("div", { staticClass: "list-card-import" }, [
      _vm.isOneImportDirectoryEnabled
        ? _c("div", { staticClass: "category" }, [
            _c(
              "span",
              { staticClass: "typographies-heading-h3 category__title" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Répertoire")) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "import-card-container" },
              [
                _vm.getImportData("company").is_enabled
                  ? _c("ImportCardType", {
                      attrs: { data: _vm.getImportData("company") }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.getImportData("individual").is_enabled
                  ? _c("ImportCardType", {
                      attrs: { data: _vm.getImportData("individual") }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.getImportData("contact").is_enabled
                  ? _c("ImportCardType", {
                      attrs: { data: _vm.getImportData("contact") }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isOneImportCatalogEnabled
        ? _c("div", { staticClass: "category" }, [
            _c(
              "span",
              { staticClass: "typographies-heading-h3 category__title" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Catalogue")) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "import-cards" }, [
              _c(
                "div",
                { staticClass: "import-card-container" },
                [
                  _vm.getImportData("product").is_enabled
                    ? _c("ImportCardType", {
                        attrs: { data: _vm.getImportData("product") }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sub-imports" },
                    [
                      _vm.getImportData("product-variation").is_enabled
                        ? _c("ImportCardType", {
                            attrs: {
                              data: _vm.getImportData("product-variation"),
                              isSubImport: true
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getImportData("product-price") &&
                      _vm.getImportData("product-price").is_enabled
                        ? _c("ImportCardType", {
                            attrs: {
                              data: _vm.getImportData("product-price"),
                              isSubImport: true
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "import-card-container" },
                [
                  _vm.getImportData("service").is_enabled
                    ? _c("ImportCardType", {
                        attrs: { data: _vm.getImportData("service") }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sub-imports" },
                    [
                      _vm.getImportData("service-price") &&
                      _vm.getImportData("service-price").is_enabled
                        ? _c("ImportCardType", {
                            attrs: {
                              data: _vm.getImportData("service-price"),
                              isSubImport: true
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isOtherImportEnabled
        ? _c("div", { staticClass: "category" }, [
            _c(
              "span",
              { staticClass: "typographies-heading-h3 category__title" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Autres données")) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "import-card-container" },
              [
                _vm.getImportData("comment").is_enabled
                  ? _c("ImportCardType", {
                      attrs: { data: _vm.getImportData("comment") }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.getImportData("stock").is_enabled
                  ? _c("ImportCardType", {
                      attrs: { data: _vm.getImportData("stock") }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.getImportData("opportunity").is_enabled
                  ? _c("ImportCardType", {
                      attrs: { data: _vm.getImportData("opportunity") }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "import-alert-wrapper" },
      [
        _c("CompassAlert", {
          staticClass: "import-choice-alert-info",
          attrs: {
            showIcon: true,
            description: _vm.localizedText.alert,
            action: _vm.actionAlert
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }